import { render, staticRenderFns } from "./PointChart.vue?vue&type=template&id=ab1cb1a8&scoped=true&"
import script from "./PointChart.vue?vue&type=script&lang=js&"
export * from "./PointChart.vue?vue&type=script&lang=js&"
import style0 from "./PointChart.vue?vue&type=style&index=0&id=ab1cb1a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1cb1a8",
  null
  
)

export default component.exports